import type { StatusColor } from "@volca/ui/tokens/component-colors";
import { PAYROLL_PALETTE } from "@/core/colors";
import { PAYROLL_RUN_STATUS } from "@/payroll/constants";
import { PayrollRunStatus } from "@/payroll/payroll.d";

export const PAYROLL_RUN_STATUS_UI = {
  [PAYROLL_RUN_STATUS.deferred]: {
    badgeColor: "information",
    palette: PAYROLL_PALETTE.processing,
    label: "Processing",
  },
  [PAYROLL_RUN_STATUS.pending]: {
    badgeColor: "neutral",
    palette: PAYROLL_PALETTE.pending,
    label: "Pending",
  },
  [PAYROLL_RUN_STATUS.processing]: {
    badgeColor: "information",
    palette: PAYROLL_PALETTE.processing,
    label: "Processing",
  },
  [PAYROLL_RUN_STATUS.completed]: {
    badgeColor: "success",
    palette: PAYROLL_PALETTE.completed,
    label: "Completed",
  },
  [PAYROLL_RUN_STATUS.failed]: {
    badgeColor: "danger",
    palette: PAYROLL_PALETTE.failed,
    label: "Failed",
  },
} satisfies Record<
  PayrollRunStatus,
  {
    badgeColor: StatusColor;
    palette: { readonly solid: string };
    label: string;
  }
>;
